import { ClockIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { business, footerGroups, images, routes } from '../data/site';
import { SiteLink } from './SiteLink';
export function Footer() {
  return <footer className="w-full border-t border-ink/10 bg-white" data-id="element-26" data-mp="32o4d0g3lai96">
      <div className="mx-auto max-w-container px-5 py-12 sm:px-8" data-id="element-27" data-mp="32lrkj907gphv">
        <div className="flex flex-col gap-6 border-b border-ink/10 pb-8 lg:flex-row lg:items-start lg:justify-between lg:gap-12" data-id="element-28" data-mp="36q9354utwwr2">
          <SiteLink to={routes.home} aria-label="Pegasus Spas home" className="shrink-0" data-id="element-29" data-mp="3ucxo5zf4x5bw">
            <img src={images.logo} alt="Pegasus Spas & Leisure Products, since 1977" className="h-[52px] w-auto" width={352} height={140} loading="lazy" data-id="element-30" data-mp="37xwcimca4j2" />
          </SiteLink>
          <p className="max-w-3xl text-[16px] leading-7 text-ink/80" data-id="element-31" data-mp="29y5fdwbbxcsw">{business.footerSeo}</p>
        </div>

        <div className="grid grid-cols-1 gap-8 py-8 sm:grid-cols-2 lg:grid-cols-6" data-id="element-32" data-mp="2ez1iw8rrqwxs">
          {footerGroups.map(group => <nav key={group.title} aria-label={group.title} data-id="element-33" data-mp="3lbmtfq7jj4eu">
              <h2 className="text-[15px] font-bold uppercase text-ink" data-id="element-34" data-mp="3gbimaqsivm1a">{group.title}</h2>
              <ul className="mt-3 space-y-1.5" data-id="element-35" data-mp="3v7zvbbd8ooko">
                {group.links.map(link => <li key={link.label} data-id="element-36" data-mp="3q8dj9595dedg">
                    <SiteLink to={link.href} className="inline-block py-1 text-[15.5px] leading-6 text-ink/80 transition-colors duration-150 ease-out hover:text-pegasus-blue" data-id="element-37" data-mp="3q7bxa5qlf7gy">
                      {link.label}
                    </SiteLink>
                  </li>)}
              </ul>
            </nav>)}
        </div>

        <div className="grid grid-cols-1 gap-6 border-t border-ink/10 pt-8 sm:grid-cols-3" data-id="element-38" data-mp="cvtn246xb9bi">
          <div className="flex items-start gap-2.5" data-id="element-39" data-mp="qtrs2izcttec">
            <MapPinIcon className="mt-1 h-5 w-5 shrink-0 text-pegasus-blue" aria-hidden="true" data-id="element-40" data-mp="mspnrnqkyr5i" />
            <address className="text-[16px] not-italic leading-6 text-ink" data-id="element-41" data-mp="tvw5sbdtv5dc">
              {business.name}
              <br data-id="element-42" data-mp="ytef42vrbmlv" />
              {business.street}
              <br data-id="element-43" data-mp="yrv00flu7hlo" />
              {business.cityStateZip}
            </address>
          </div>
          <div className="flex items-start gap-2.5" data-id="element-44" data-mp="13r7nn2kj8spb">
            <PhoneIcon className="mt-1 h-5 w-5 shrink-0 text-pegasus-blue" aria-hidden="true" data-id="element-45" data-mp="18l2eqr2gw9yf" />
            <p className="text-[16px] leading-6 text-ink" data-id="element-46" data-mp="1cmdywh2ko2z8">
              Voice or text
              <br data-id="element-47" data-mp="1hk5w9qlzkhat" />
              <a href={business.phoneHref} className="font-bold text-pegasus-blue underline decoration-pegasus-blue/40 underline-offset-4 transition-colors duration-150 ease-out hover:text-pegasus-magenta" data-id="element-48" data-mp="1hjnqo3dfoqq8">
                {business.phone}
              </a>
            </p>
          </div>
          <div className="flex items-start gap-2.5" data-id="element-49" data-mp="3od85lcgo84lz">
            <ClockIcon className="mt-1 h-5 w-5 shrink-0 text-pegasus-blue" aria-hidden="true" data-id="element-50" data-mp="3tb9lxpmppptr" />
            <div className="text-[16px] leading-6 text-ink" data-id="element-51" data-mp="2afdh79cf72n7">
              {business.hours.map(entry => <div key={entry.days} data-id="element-52" data-mp="25nc8fxegnu1x">
                  {entry.days} {entry.time}
                </div>)}
            </div>
          </div>
        </div>

        <p className="mt-8 text-[14.5px] text-ink/70" data-id="element-53" data-mp="1wnz05822pbis">
          © {new Date().getFullYear()} {business.name}. Brooklyn, Michigan.
        </p>
      </div>
    </footer>;
}